export default __webpack_public_path__ + "static/mercury-starship-lockup-c03b4606651585b307c3d11674a3e2c3.png";